import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

export const name = 'reportFacet';
const initialState: ReportFacetState = {
	faceted: false,
	sport: null,
	league: null,
	startTime: dayjs().format('YYYY-MM-DD'),
	endTime: dayjs().add(1, 'day').format('YYYY-MM-DD'),
	status: null,
	hasAirings: true,
	page: 0,
	count: 0,
	autoRefetch: true,
	sorting: {
		orderBy: -1,
		orderDirection: ''
	}
};

export const reportFacetSlice = createSlice({
	name,
	initialState,
	reducers: {
		setSportFacet: (state, { payload }): void => {
			state.sport = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setLeagueFacet: (state, { payload }): void => {
			state.league = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setStartTimeFacet: (state, { payload }): void => {
			state.startTime = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setEndTimeFacet: (state, { payload }): void => {
			state.endTime = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setTimesFacet: (state, { payload }): void => {
			const { startTime, endTime } = payload;
			state.startTime = startTime;
			state.endTime = endTime;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setStatusFacet: (state, { payload }): void => {
			state.status = payload;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		toggleHasAiringsFacet: (state): void => {
			state.hasAirings = !state.hasAirings;
			state.page = initialState.page;
			state.count = initialState.count;
			state.faceted = true;
		},
		setPage: (state, { payload }): void => {
			state.page = payload;
		},
		setCount: (state, { payload }): void => {
			state.count = payload;
		},
		toggleAutoRefetch: (state): void => {
			state.autoRefetch = !state.autoRefetch;
		},
		setSorting: (state, { payload }): void => {
			state.sorting = payload;
		},
		resetAllFacets: (state): void => {
			state.sport = initialState.sport;
			state.league = initialState.league;
			state.startTime = initialState.startTime;
			state.endTime = initialState.endTime;
			state.status = initialState.status;
			state.hasAirings = initialState.hasAirings;
			state.page = initialState.page;
			state.count = initialState.count;
			state.autoRefetch = initialState.autoRefetch;
			state.sorting = initialState.sorting;
			state.faceted = initialState.faceted;
		}
	}
});

export const {
	setSportFacet,
	setLeagueFacet,
	setStartTimeFacet,
	setEndTimeFacet,
	setTimesFacet,
	setStatusFacet,
	toggleHasAiringsFacet,
	setPage,
	setCount,
	resetAllFacets,
	toggleAutoRefetch,
	setSorting
} = reportFacetSlice.actions;

export default reportFacetSlice.reducer;

export interface ReportFacetState {
	faceted: boolean;
	sport: string | null;
	league: string | null;
	startTime: string | null;
	endTime: string | null;
	status: string | null;
	hasAirings: boolean;
	page: number;
	count: number;
	autoRefetch: boolean;
	sorting: {
		orderBy: number;
		orderDirection: string;
	};
}
